import {
  PROFILE_TEAMS,
  EDIT_TEAMS,
  SET_MESSAGE,
  ADD_TEAM,
  DELETE_TEAM,
} from "./types";
import userProfile from "services/user.profile";

export const profileTeams = (dispatch) => {
  return userProfile.getProfileTeams().then(
    ({ data }) => {
      dispatch({
        type: PROFILE_TEAMS,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const editTeams = (id, teamValue) => (dispatch) => {
  return userProfile.changeProfileTeams(id, teamValue).then(
    ({ data }) => {
      dispatch({
        type: EDIT_TEAMS,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const addTeam = (teamValue, membersId) => (dispatch) => {
  return userProfile.addProfileTeam(teamValue, membersId).then(
    ({ data }) => {
      dispatch({
        type: ADD_TEAM,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const deleteTeam = (id) => (dispatch) => {
  return userProfile.deleteProfileTeam(id).then(
    () => {
      dispatch({
        type: DELETE_TEAM,
        payload: { id },
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};
